<template>
    <section class="userSteps">
        <Header />
        <div class="d-flex justify-content-end padSpace" @click="store.clearMessage" v-if="store.error.msg">
            <button type="button" class="close_btn">
                <vue-feather size="26" type="x"></vue-feather>
            </button>
        </div>
        <div class="publicProfile row align-items-center">
            <div class="col-12 d-flex align-items-center justify-content-between mb-4">
                <router-link class="d-flex align-items-center backBtn medium" :to="{name : 'create_broker_account2',params:{'id':this.$route.params.id}}">
                    <vue-feather class="me-2" type="arrow-left" size="15"></vue-feather> {{$t('financial_detail.text1')}}
                </router-link>
                <div class="counterStep text-end">
                    <p>{{$t('financial_detail.text2')}}</p>
                </div>
            </div>
            <div class="col-12">
                <div class="mainTitle mb-5">
                    <h3 class="mb-3 clash">{{$t('financial_detail.text3')}}<span class="bgTitle">{{$t('financial_detail.text4')}}</span></h3>
                </div>
            </div>
            <div class="col-12">
                <h4 class="mb-4">{{$t('financial_detail.text5')}}</h4>
                <Form class="row personalDetails" @submit="submit">
                    <div v-for="(value, key) of (store.flavorData?.isEu) ? financialDetailsEU : financialDetailsGlobal" class="col-12" :key="key">
                        <h6 class="medium">{{ value.label }}</h6>
                        <ul class="boxRadio d-flex align-items-center flex-wrap mb-0">
                            <li v-for="option in value.values" :key="option">
                                <label :class="{active: form[value.key] == option.value}" class="customCheckBox radio mb-3">
                                    <span class="name f-15">{{ option.label }}</span>
                                     <Field
                                      type="radio"
                                      :name="value.key"
                                      :value="option.value"
                                      v-model="form[value.key]"
                                      rules="required"
                                    />
                                    <span class="checkmark"></span>
                                </label>
                            </li>
                        </ul>
                        <div class="row" v-if="store.flavorData?.isEu && value.key == 'emp_status' && (form?.emp_status != '03' && form?.emp_status != '04')">
                            <div class="col-12 col-xl-4">
                                <float-label class="form-group">
                                    <Field
                                    class="form-control"
                                    name="occupation"
                                    :placeholder="$t('financial.text1')"
                                    v-model="occupation"
                                    rules="required"
                                    />
                                    <ErrorMessage class="text-danger" name="occupation" />
                                </float-label>
                            </div>
                            <div class="col-12 col-xl-4">
                                <float-label class="form-group">
                                    <Field
                                    class="form-control"
                                    name="employer name"
                                    :placeholder="$t('financial.text2')"
                                    v-model="employername"
                                    rules="required"
                                    />
                                    <ErrorMessage class="text-danger" name="employer name" />
                                </float-label>
                            </div>
                            <div class="col-12 col-xl-4">
                                <div class="countrySelect form-group position-relative filter-dropdown" :class="[{'selected' : business_activity}]">
                                    <a @click="selectButton = !selectButton" href="javascript:void(0)"
                                        class="selectButton d-flex align-items-center justify-content-between"><span
                                            class="d-flex align-items-center" v-if="business_activity">{{$t(`financial.${showLabel['business_activity']}`)}}</span>
                                                <span v-else>&nbsp;</span>
                                        <vue-feather size="20" type="chevron-down"></vue-feather>
                                    </a>
                                    <label class="afterSelect">{{$t('financial.text3')}}</label>
                                    <ul class="dropdown_menu_animated scrollable" :class="selectButton ? 'show' : ''" > 
                                        <!-- <li class="form-group mb-1">
                                            <input type="text" :placeholder="$t('personal_info.text8')" class="form-control radius-0" v-model="activitySearch" />
                                        </li> -->
                                        <li v-for="value,key in static_vars.bussinessActivity" :key="key">
                                            <a href="javascript:void(0)" class="d-flex align-items-center" @click="business_activity = key;showLabel['business_activity']=value;selectButton = false;activitySearch = ''" >
                                            {{$t(`financial.${value}`)}}</a>
                                        </li>
                                    </ul>
                                </div>
                                <span v-if="activityError && store.flavorData?.isEu" class="text-danger">{{$t('personal_info.text24')}}</span>
                            </div>
                        </div>
                        <div v-if="store.flavorData?.isEu && value.key == 'source_of_fund' && 'source_of_fund' in form && form.source_of_fund == '08'">
                            <div class="col-12">
                                <float-label class="form-group">
                                    <Field
                                    class="form-control"
                                    name="others"
                                    :placeholder="$t('financial.text4')"
                                    v-model="fund_others"
                                    rules="required"
                                    />
                                    <ErrorMessage class="text-danger" name="others" />
                                </float-label>
                            </div>
                        </div>
                    <ErrorMessage :name="value.key" class="text-danger"/>
                    </div>
                    <div class="col-6 mt-4">
                        <button type="submit" class="grd_btn full_size">{{$t('financial_detail.text6')}}</button>
                    </div>
                </Form>
            </div>
        </div>
    </section>
</template>

<script>
import { useMainStore } from "@/store";
import FloatLabel from 'vue-float-label/components/FloatLabel'
import { Form, Field, ErrorMessage } from "vee-validate";
export default {
     setup() {
        const store = useMainStore();
        return { store };
    },
    data() {
        return {
            form: {},
            selectButton : false,
            occupation : '',
            employername : '',
            business_activity : '',
            activitySearch : '',
            showLabel : {'business_activity' : ''},
            activityError : false,
            fund_others : '',
            financialDetailsEU: {
                ac_opening_reason: {
                  label: "Purpose And Reason For Requesting The Account Opening",
                  key: "ac_opening_reason",
                  values: [
                    { value: '01', label: 'Speculative Trading' },
                    { value: '02', label: 'Intraday Trading' },
                    { value: '03', label: 'Savings' },
                    { value: '04', label: 'Hedging' },
                  ]
                },
                emp_status: {
                  label: "Employment Status",
                  key: "emp_status",
                  values: [
                    { value: '01', label: 'Employed' },
                    { value: '02', label: 'Self-Employed' },
                    { value: '03', label: 'Unemployed' },
                    { value: '04', label: 'Student' },
                    { value: '05', label: 'Retired' }
                  ]
                },
                education: {
                  label: "Education",
                  key: "education",
                  values: [
                    { value: '01', label: 'University/College' },
                    { value: '02', label: 'Secondary Education' },
                    { value: '03', label: 'Primary Education' },
                    { value: '04', label: 'No Education' },
                  ]
                },
                yearly_income: {
                  label: "Estimated Yearly Income (EUR)",
                  key: "yearly_income",
                  values: [
                    { value: '01', label: '0-10,000' },
                    { value: '02', label: '10,000-50,000' },
                    { value: '03', label: '50,000-100,000' },
                    { value: '04', label: '100,000-200,000' },
                    { value: '05', label: 'Above 200,000' },
                  ]
                },
                net_worth: {
                  label: "Estimated Net Worth (EUR)",
                  key: "net_worth",
                  values: [
                    { value: '01', label: '0-50,000 ' },
                    { value: '02', label: '50,000-100,000 ' },
                    { value: '03', label: '100,000-300,000 ' },
                    { value: '04', label: 'Above 300,000 ' },
                    ]
                },
                net_disposable_income: {
                  label: "Please state your average yearly net disposable income i.e. total income minus expenses e.g. living expenses, mortgage/rent payments, debt instalments, credit card payments etc.",
                  key: "net_disposable_income",
                  values: [
                    { value: '01', label: 'up to €10,000' },
                    { value: '02', label: '€10,000-€20,000' },
                    { value: '03', label: '€20,000-€50,000' },
                    { value: '04', label: 'Above €50,000' },
                 ]
                },
                invested_trading_amount: {
                  label: "Please specify the amount to be invested in your trading account (EUR)",
                  key: "invested_trading_amount",
                  values: [
                    { value: '01', label: '0 - 1000' },
                    { value: '02', label: '1,000 – 5,000' },
                    { value: '03', label: '5,000 – 10,000' },
                    { value: '04', label: '10,000 - 50,000' },
                    { value: '05', label: 'Above 50,000' },
                 ]
                },
                account_turnover: {
                  label: "Please define your anticipated turnover in your trading account (EUR):",
                  key: "account_turnover",
                  values: [
                    { value: '01', label: '0 – 5,000' },
                    { value: '02', label: '5,000 – 25,000' },
                    { value: '03', label: '25,000 – 50,000' },
                    { value: '04', label: '50,000 – 100,000' },
                    { value: '05', label: 'Above 100,000' },
                 ]
                },
                source_of_fund: {
                  label: "Source of Funds",
                  key: "source_of_fund",
                  values: [
                    { value: '01', label: 'Employment' },
                    { value: '02', label: 'Inheritance' },
                    { value: '03', label: 'Investment' },
                    { value: '04', label: 'Real Estate' },
                    { value: '05', label: 'Savings' },
                    { value: '06', label: 'Loan' },
                    { value: '07', label: 'Private Pension' },
                    { value: '08', label: 'Others' },
                 ]
                },
                nature_of_transaction: {
                  label: "Nature of Transactions",
                  key: "nature_of_transaction",
                  values: [
                    { value: '01', label: 'Short term investment' },
                    { value: '02', label: 'Long term investment' },
                 ]
                },
                origin_of_funds: {
                  label: "Origin of Funds",
                  key: "origin_of_funds",
                  values: [
                    { value: '01', label: 'Credit card' },
                    { value: '02', label: 'Bank Transfer' },
                    { value: '03', label: 'APM transactions' },
                 ]
                },
            },
            financialDetailsGlobal: {
                empStatus: {
                  label: "Employment Status",
                  key: "empStatus",
                  values: [
                    { value: '01', label: 'Employed' },
                    { value: '02', label: 'Self-Employed' },
                    { value: '03', label: 'Unemployed' },
                    { value: '04', label: 'Student' },
                    { value: '05', label: 'Retired' }
                  ]
                },
                occupation: {
                  label: "Business Activity",
                  key: "occupation",
                  values: [
                    { value: '01', label: 'Director' },
                    { value: '02', label: 'Head/Manager of a Department' },
                    { value: '03', label: 'Partner' },
                    { value: '04', label: 'Office Manager' },
                    { value: '05', label: 'Admin/Secretarial' },
                    { value: '06', label: 'Professional Staff' },
                    { value: '07', label: 'Accountant' },
                    { value: '08', label: 'Caretaker' },
                    { value: '09', label: 'Other' }
                  ]
                },
                estYearlyIncome: {
                  label: "Estimated Yearly Income",
                  key: "estYearlyIncome",
                  values: [
                    { value: '01', label: '< 25k' },
                    { value: '02', label: '25k - 50k' },
                    { value: '03', label: '50k - 100k' },
                    { value: '04', label: '100k - 250k' },
                    { value: '05', label: '250k - 500k' },
                    { value: '06', label: '> 500k' }
                  ]
                },
                estNetWorth: {
                  label: "Estimated Net Worth",
                  key: "estNetWorth",
                  values: [
                    { value: '01', label: '< €25k ' },
                    { value: '02', label: '€25k - €50k ' },
                    { value: '03', label: '€50k - €100k ' },
                    { value: '04', label: '€100k  - €250k ' },
                    { value: '05', label: '€250k  - €500k ' },
                    { value: '06', label: '> €500k ' }]
                },
                antAccountTurnover: {
                  label: "Anticipated Account Turnover",
                  key: "antAccountTurnover",
                  values: [
                    { value: '01', label: '€0 - €10k' },
                    { value: '02', label: '€10k - €50k' },
                    { value: '03', label: '€50k -€100k' },
                    { value: '04', label: '€100k - €250k' },
                    { value: '05', label: '€250k - €500k' },
                    { value: '06', label: '€500k +' }]
                },
            },
        }
    },
    components : {
        Form,
        Field,
        ErrorMessage,
        FloatLabel
    },
    watch : {
        'business_activity'(){
            if(this.business_activity){
                this.activityError = false
            }else{
                this.activityError = true
            }
        }
    },
    methods:{
        submit(){
            if(this.store.flavorData?.isEu){
                if('emp_status' in this.form){
                    let formData = {
                        "step": "2",
                        "brokerId": this.$route.params.id,
                        "source_of_fund_other" : this.fund_others,
                        "occupation" : this.business_activity,
                        "position" : this.occupation,
                        "emp_name" : this.employername
                    }
                    if(this.form?.emp_status == '03' || this.form?.emp_status == '04'){
                        this.activityError = false
                    }else{
                        if(this.business_activity){
                            this.activityError = false
                        }else{
                            this.activityError = true
                        }
                    }
                    if(!this.activityError){
                        formData = Object.assign(formData, this.form)
                        this.store.saveBrokerFinancialDetail(formData,true,this.$route.params.id,this)
                    }
                }
            }else{
                let formData = {
                    "brokerId": this.$route.params.id,
                    'emp_status' : this.form.empStatus,
                    "occupation" : this.form.occupation,
                    "yearly_income" : this.form.estYearlyIncome,
                    "net_worth" : this.form.estNetWorth,
                    "account_turnover" : this.form.antAccountTurnover
                }
                this.store.saveBrokerFinancialDetail(formData,true,this.$route.params.id,this)
            }
        }
    },
}
</script>
